import {createContext, m} from '@codeurs/front'
import toPath from 'lodash/toPath'
import {Component, useContext} from 'react'

export const I18nContext = createContext<{language: string; data: any}>(
	undefined
)

const getIn = (
	obj: any,
	key: string | Array<string>,
	def?: any,
	p: number = 0
) => {
	const path = toPath(key)
	while (obj && p < path.length) obj = obj[path[p++]]
	return obj === undefined ? def : obj
}

export class I18n<T> extends Component<{
	language: string
	data: T
}> {
	render() {
		return (
			<I18nContext.Provider value={this.props}>
				{this.props.children}
			</I18nContext.Provider>
		)
	}
}

const translate = (data: any, key: string) => {
	const res = getIn(data, key)
	if (res === undefined) console.error(`Undefined translation key: ${key}`)
	return res
}

export const t = (key: string) => {
	const {data} = useContext(I18nContext)
	return translate(data, key)
}

export const useTranslation = (prefix?: string) => {
	const {data} = useContext(I18nContext)
	return (key?) => translate(data, prefix ? `${prefix}.${key}` : key)
}

export const useLanguage = () => {
	const {language} = useContext(I18nContext)
	return language
}
